import { render, staticRenderFns } from "./EmailSetup.vue?vue&type=template&id=af60c5a6"
import script from "./EmailSetup.vue?vue&type=script&lang=js"
export * from "./EmailSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports